import React, { Component } from "react";
import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";
import EntityRights from "./EntityRights";
import { Splitter } from "@progress/kendo-react-layout";
import RightsBasedOnEntity from "./RightsBasedOnEntity";
import { GeneralRights } from "./GeneralRights";
import { RoleContext } from "./Context/RoleContext";
import { withTranslation } from "react-i18next";
import Scrollable from "../Shared/Edit/Scrollable";

class Rights extends Component {
	static contextType = RoleContext
	constructor(props) {
		super(props);
		this.state = {
			selected: 0,
			panes: [
				{ size: "100%", min: "40%", collapsible: false },
				{ min: "0%", collapsible: false }
			]
		}
	}

	render() {
		const { t } = this.props;
		return (
			<Splitter onChange={this.onSplitterSizeChange} panes={this.state.panes}>
				<div className="h-100">
					<TabStrip className="h-100" animation={false} selected={this.state.selected} onSelect={this.handleTabs}>
						<TabStripTab title={t("role_rights_tabs.general_tab")}>
							<GeneralRights />
						</TabStripTab>
						<TabStripTab title={t("role_rights_tabs.objects_tab")}>
							<Scrollable>
								<EntityRights
									subscription={this.props.subscription}
									selectedRole={this.context.state.selectedRole}
									projectName={this.props.projectName}
									projectId={this.props.projectId} />
							</Scrollable>
						</TabStripTab>
					</TabStrip>
				</div>
				<div className="h-100">
					{this.context.state.selectedEntity._id && this.state.selected === 1 && (
						<RightsBasedOnEntity
							selectedEntity={this.context.state.selectedEntity}
							key={this.context.state.selectedEntity._id}
							selectedRole={this.context.state.selectedRole}
							orgName={this.props.orgName}
							organization={this.props.organization}
							projectName={this.props.projectName}
							projectId={this.props.projectId} />
					)}
				</div>
			</Splitter>
		);
	}

	handleTabs = (e) => {
		let panes
		if (e.selected === 0 || e.selected === 2) {
			panes = [
				{ size: "100%", min: "60%", collapsible: false },
				{ min: "0%", collapsible: false }
			]
		} else {
			panes = [
				{ size: "48%", min: "52%", collapsible: false },
				{ min: "20%", collapsible: false }
			]
		}
		this.setState({ panes: panes, selected: e.selected })
	}

	onSplitterSizeChange = (e) => {
		this.setState({ panes: e.newState })
	}
}

export default withTranslation([
	"role/common"
], {
	withRef: true,
})(Rights);
